import findIndex from 'lodash/findIndex'
import moment from 'moment'

const initialState = {
  data:[],
  search:'',
  filter:{
    type:1,
    srvg:[],
    comp:[],
    from:moment().subtract(6, "months").format('Y-MM-DD'),
    to:moment().add(2, "months").format('Y-MM-DD')
  },
  sort:{
    field:'post_bdate',
    asc:0
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_EXPENSES':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_EXPENSES':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_EXPENSES':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_EXPENSES':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_EXPENSE':
      const index = findIndex(state.data, { post_id: action.payload.post_id });
      if (index >= 0) {
        return {
          ...state,
          data: [
            ...state.data.slice(0, index),
            action.payload,
            ...state.data.slice(index + 1)
          ]
        }
      }
      return state;
    case 'CREATE_EXPENSE':
      return {
        ...state,
        data: [
          ...state.data,
          action.payload
        ]
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/expenses.js